import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { exitKiosk } from "utils/kiosk";
import "./KioskControls.scss";

/**
 * Floating controls shown while kiosk mode is active.
 *
 * Renders an unobtrusive "exit kiosk" button (top-right, revealed on hover/focus)
 * and wires the Escape key and the browser's own fullscreen-exit (F11 / Esc) to
 * leave kiosk mode — so the user is never trapped with the Console chrome hidden.
 */
export const KioskControls = () => {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const leave = () => exitKiosk(history, location);

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") leave();
        };
        // The user left browser fullscreen (Esc / F11) while in kiosk — also drop
        // the kiosk flag so a single Escape returns the full Console chrome.
        const onFullscreenChange = () => {
            if (!document.fullscreenElement) leave();
        };

        document.addEventListener("keydown", onKeyDown);
        document.addEventListener("fullscreenchange", onFullscreenChange);
        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.removeEventListener("fullscreenchange", onFullscreenChange);
        };
    }, [history, location]);

    return (
        <button
            type="button"
            className="KioskControls__exit"
            title="Exit kiosk mode (Esc)"
            aria-label="Exit kiosk mode"
            onClick={() => exitKiosk(history, location)}
        >
            <Icon className="KioskControls__exitIcon" icon={IconCollection.arrowCollapse} />
        </button>
    );
};

export default KioskControls;
